<div class="container">
    <div class="row row-cols-2 row-cols-md-2 row-cols-xl-4 g-4">

    <app-services-card header="Workers' Compensation" link="services/workerscomp" icon="fas fa-briefcase-medical"></app-services-card>
    <app-services-card header="General & Professional Liability" link="services/generalprof" icon="fas fa-shield-alt"></app-services-card>
    <app-services-card header="Commercial Property" link="services/commercialproperty" icon="fas fa-building"></app-services-card>
    <app-services-card header="Employment Practices Liability" link="services/epli" icon="fas fa-balance-scale"></app-services-card>

    </div>
</div>